import Seat from '../../../components/Seat';
import WagonBaggage from '../../../components/WagonBaggage';
import WagonTable from '../../../components/WagonTable';
import WagonToilet from '../../../components/WagonToilet';
import WagonDoor from '../../../components/WagonDoor';

function FirstFloor({
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>

        <div
          className="seats-row left"
          style={{ width: '755.3px', marginLeft: '100px' }}
        >
          <WagonDoor />
          <WagonBaggage />
          {[
            [76, 75],
            [73, 74],
            [68, 69],
            [63, 64],
            [58, 59],
            [53, 54],
            [48, 49],
            [43, 44],
            [38, 39],
          ]?.map((seatRow) => (
            <div
              className={`seat-column ${!seatRow[2] && 'justify-end'}`}
              key={seatRow[0]}
            >
              {seatRow[2] && (
                <Seat
                  seat={seats?.[seatRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />
          {[
            [34, 33],
            [29, 28],
            [24, 23],
            [19, 18],
            [14, 13],
            [9, 8],
            [4, 3],
          ]?.map((seatRow) => (
            <div
              className={`seat-column reversed ${!seatRow[2] && 'justify-end'}`}
              key={seatRow[0]}
            >
              {seatRow[2] && (
                <Seat
                  seat={seats?.[seatRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
        </div>
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '100px' }}
        >
          <WagonDoor
            className="flex items-end"
          />
          <WagonToilet
            style={{
              display: 'flex',
              alignItems: 'end',
            }}
          />
          <div className="seat-column opacity-0 pointer-events-none">
            <Seat
              seat={seats?.[0]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
          </div>
          {[
            [70, 71, 72],
            [65, 66, 67],
            [60, 61, 62],
            [55, 56, 57],
            [50, 51, 52],
            [45, 46, 47],
            [40, 41, 42],
            [35, 36, 37],
          ]?.map((seatRow) => (
            <div
              className={`seat-column ${!seatRow[2] && 'justify-end'}`}
              key={seatRow[0]}
            >
              {seatRow[2] && (
                <Seat
                  seat={seats?.[seatRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />
          {[
            [32, 31, 30],
            [27, 26, 25],
            [22, 21, 20],
            [17, 16, 15],
            [12, 11, 10],
            [7, 6, 5],
            [2, 1],
          ]?.map((seatRow) => (
            <div
              className="seat-column reversed"
              key={seatRow[0]}
            >
              {seatRow[2] && (
                <Seat
                  seat={seats?.[seatRow[2]]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
